import { menu_hover } from '../modules/page';

export default {
	init() {
		// JavaScript to be fired on the home page
		menu_hover();
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js